export default "__VITE_ASSET__a2212d2a__"